/** Bekannte Mail-Anbieter mit IMAP/SMTP-Einstellungen */

export const MAIL_PROVIDERS = [
  {
    id: 'webde',
    label: 'WEB.DE',
    domains: ['web.de'],
    imapHost: 'imap.web.de',
    imapPort: 993,
    smtpHost: 'smtp.web.de',
    smtpPort: 587,
    hint: 'Bitte bei web.de den POP3/IMAP-Abruf aktivieren.',
  },
  {
    id: 'gmx',
    label: 'GMX',
    domains: ['gmx.de', 'gmx.net', 'gmx.at', 'gmx.ch'],
    imapHost: 'imap.gmx.net',
    imapPort: 993,
    smtpHost: 'mail.gmx.net',
    smtpPort: 587,
    hint: 'POP3/IMAP-Zugriff muss im GMX-Konto freigeschaltet sein.',
  },
  {
    id: 'gmail',
    label: 'Gmail',
    domains: ['gmail.com', 'googlemail.com'],
    imapHost: 'imap.gmail.com',
    imapPort: 993,
    smtpHost: 'smtp.gmail.com',
    smtpPort: 587,
    hint: 'Kein normales Google-Passwort — „Mit Google anmelden“ oder App-Passwort.',
  },
];

export function emailDomain(email = '') {
  const parts = String(email || '').trim().toLowerCase().split('@');
  return parts.length === 2 ? parts[1] : '';
}

export function detectMailProvider(email) {
  const domain = emailDomain(email);
  if (!domain) return null;
  return (
    MAIL_PROVIDERS.find((p) => p.domains.some((d) => domain === d || domain.endsWith(`.${d}`))) ||
    null
  );
}

export function providerToMailServer(provider) {
  if (!provider) return null;
  return {
    imapHost: provider.imapHost,
    smtpHost: provider.smtpHost,
    imapPort: provider.imapPort,
    smtpPort: provider.smtpPort,
    host: provider.imapHost,
  };
}
